module.exports = __webpack_public_path__ + "img/weather_01.2deec628.png";